import { CREATE, DELETE, EDIT } from '@/constants/api'

export const DONATIONS = 'donations'
export const DONATION = 'donation'

export const ENDPOINTS = {
  CREATE_DONATION: `/${DONATIONS}/${CREATE}`,
  GET_DONATIONS: `/${DONATIONS}/`,
  GET_DONATION: `/${DONATIONS}/${DONATION}`,
  UPDATE_DONATION: `/${DONATIONS}/${EDIT}`,
  VERIFY_DONATION: `/${DONATIONS}/verify`,
  DELETE_DONATION: `/${DONATIONS}/${DELETE}`,
  UPLOAD_DEPOSIT_RECEIPT: `/${DONATIONS}/upload-deposit-receipt`,
  GET_CASH_DEPOSIT_RECEIPT: `/${DONATIONS}/download-cash-receipt`,
  SEND_REGISTRATION_REQUEST: `/${DONATIONS}/send-registration-request`,
}
